import * as React from "react";
import styled from "styled-components";
import Banner from "./components/banner";

const BackgroundWrapper = styled.div`
  width: 100%;
  height: ${(props: IProps) => props.height};
  position: absolute;

  .banner {
    width: 100vw;
    height: 104vw;
  }
`;

interface IProps {
  height: string;
}

const BottomBanner = (props: IProps) => {
  return (
    <BackgroundWrapper {...props}>
      <Banner className="banner" />
    </BackgroundWrapper>
  );
};

export default BottomBanner;
